import { type Theme } from '../types';
import { defaultTheme, defaultDarkMode } from './base';

export const defaultColorTheme: Theme = { ...defaultTheme, darkMode: defaultDarkMode };
